window.AddProductToCart = function(variantId,props) {
  $("body").addClass("loading");
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": variantId,
      "quantity": 1,
      "properties":props
    },
    dataType: 'json',
    success: function() {   
      $("body").removeClass("loading");
      window.location.href = '/cart';
    },
    error: function(response) {
      $("body").removeClass("loading");
      console.error("Failed to add product to cart");
    }
  });
}

window.fetchUpdatedCartData = function() {
  $.ajax({
    type: 'GET',
    url: '?section_id=cart-template',
    success: function(responseText) {
      // FIX 1: Wrap innerHTML swaps in requestAnimationFrame to prevent forced layout recalculation
      window.requestAnimationFrame(function() {
        var html = new DOMParser().parseFromString(responseText, 'text/html')
        var destination = document.querySelector('#CartCount');
        var source = html.querySelector('cart-drawer');
        if(source && destination) destination.innerHTML = source.innerHTML;
        // Added safety check for mobileDestination to prevent console errors
        if(source && typeof mobileDestination !== 'undefined') mobileDestination.innerHTML = source.innerHTML;
      });
    },
    error: function() {
      console.error("Failed to fetch updated cart data");
    }
  });
}

function openVariantDrawer() {
  const $drawer = $('.bottomVariantDrawer');
  const $overlay = $('.variantDrawerOverlay');

  $drawer.addClass('active').removeClass('closing');
  $overlay.addClass('active');
  $('body').css('overflow', 'hidden');
}

function closeVariantDrawer(status) {
  const $drawer = $('.bottomVariantDrawer');
  const $overlay = $('.variantDrawerOverlay');

  $drawer.addClass('closing');

  setTimeout(() => {
    $drawer.removeClass('active closing');
    $overlay.removeClass('active');
    $('body').css('overflow', '');
  }, 300);
}

$(document).ready(function(){
  $('body').on('click', '.m_singleATC, .m_testimonialATC', function(e){
    e.preventDefault();
    var id = $(this).attr('data-variant-id');
    window.AddProductToCart(id);
  });
  $('body').on('click', '.m__ATC_Btn', function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    window.AddProductToCart(id);
  });
  
  $('body').on('click', '.m_filterTitle', function(e){
    $(this).find('svg').toggleClass('rotateSVG');
    $(this).parent().find('.m_filterContent').toggle(400);
  });

  $('body').on('click', '.m_giftCardCTA', function(e){
    e.preventDefault();
    openVariantDrawer();
    $('.bottomVariantDrawer .m_drawerContent').html($(this).parents('.gitem').find('.m_variantWrapper').html());
  });

  $(document).on('click', '.variantDrawerOverlay, .variantDrawerClose', function(e){
    e.preventDefault();
    closeVariantDrawer();
    $('.bottomVariantDrawer .m_drawerContent').html('');
  });
  
  $('body').on('click', '.m_giftDenominations li', function(){
    $(this).parent().find('li').removeClass('activeDenomination');
    $(this).addClass('activeDenomination');
  });

  $('body').on('click', '.m_giftCardATC', function(e) {
    e.preventDefault();
  
    var $wrapper = $(this).closest('.m_giftCardWrapper');
    var variantId = $wrapper.find('.activeDenomination').data('variant-id');
    var props = {
      "Recipient name": $wrapper.find('input[name="properties[Recipient name]"]').val(),
      "Recipient email": $wrapper.find('input[name="properties[Recipient email]"]').val(),
      "Sender Name": $wrapper.find('input[name="properties[Sender Name]"]').val(),
      "Message": $wrapper.find('textarea[name="properties[Message]"]').val()
    };
  
    window.AddProductToCart(variantId, props);
  });

});

// A+ product dropdown js
document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".m-clinical-heading, .m-des-heading, .m-faq-heading, .m-how-to-use-heading, .m-benefits-heading, .m-key-benefit-heading, .biw-heading");
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  // FIX 2: Wrap initial display toggles in requestAnimationFrame to stop blocking the critical paint path
  window.requestAnimationFrame(function() {
    headers.forEach(header => {
      const content = header.nextElementSibling;
      const parent = header.parentElement;
      const isSpecialSection = header.classList.contains("m-clinical-heading") || header.classList.contains("biw-heading");
      
      // Set initial state
      if (isMobile) {
        // Mobile view - only special sections are open
        content.style.display = isSpecialSection ? "block" : "none";
        parent.classList.toggle("active", isSpecialSection);
      } else {
        // Desktop view - all sections are open
        content.style.display = "block";
        parent.classList.add("active");
      }
      
      // Click handler
      header.addEventListener("click", function () {
        // Batch the height calculation changes on click
        window.requestAnimationFrame(function() {
          const shouldShow = content.style.display === "none";
          content.style.display = shouldShow ? "block" : "none";
          parent.classList.toggle("active", shouldShow);
        });
      });
    });
  });
});